import { render, staticRenderFns } from "./plusGiveTicket.vue?vue&type=template&id=33ee66cc&scoped=true"
import script from "./plusGiveTicket.vue?vue&type=script&lang=js"
export * from "./plusGiveTicket.vue?vue&type=script&lang=js"
import style0 from "./plusGiveTicket.vue?vue&type=style&index=0&id=33ee66cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ee66cc",
  null
  
)

export default component.exports